import { createContext } from "react";

export const UrlTokenContext = createContext<string | null>(null);
